import { FieldBase } from '@/components/form/fieldBase';
import { useFieldContext } from '@/components/form/formHooks';
import { FieldProps } from '@/components/form/types';
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';

export function FieldTextArea({
  label,
  description,
  placeholder,
  className,
  isRequired,
  showCounter,
  maxLength,
  ...props
}: FieldProps & React.ComponentProps<'textarea'> & { showCounter?: boolean }) {
  const field = useFieldContext<string>();
  return (
    <FieldBase label={label} description={description} isRequired={isRequired}>
      <Textarea
        className={cn(
          'border border-neutrals-300 min-h-21',
          'ring-0 ring-offset-0 focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0',
          'outline-hidden focus:outline-hidden shadow-none',
          className,
        )}
        placeholder={placeholder}
        value={field.state.value ?? ''}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        showCounter={showCounter}
        maxLength={maxLength}
        {...props}
      />
    </FieldBase>
  );
}
